import { render, staticRenderFns } from "./DeactivateStream.vue?vue&type=template&id=1398d589&scoped=true"
import script from "./DeactivateStream.vue?vue&type=script&lang=js"
export * from "./DeactivateStream.vue?vue&type=script&lang=js"
import style0 from "./DeactivateStream.vue?vue&type=style&index=0&id=1398d589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1398d589",
  null
  
)

export default component.exports